import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

import { Tooltip } from '@mui/material';

import { url ,fileUploadUrl} from "../../constant";


const rootUrl = fileUploadUrl;

console.log(rootUrl); // "http://127.0.0.1:8000"

function HeroSectionDashboard() {
  const [tab, setTab] = useState(0);
  const [items, setItems] = useState([]);
  const [formState, setFormState] = useState({
    title: "",
    subtitle: "",
    button_text: "",
    image_path: "",
    previewImage: "", // <-- this holds the image URL from the backend
  });
  const [loading, setLoading] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const [editItemId, setEditItemId] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [currentPageIndex, setCurrentPageIndex] = useState(0); // Manage pagination state

  useEffect(() => {
    fetchItems();
  }, []);

  const fetchItems = () => {
    setLoading(true);
    fetch(`${url}auth/get-hero-sections`)
      .then((r) => r.json())
      .then((data) => {
        
        setItems(data.data || [])
        console.log("get-hero-sections",data);

      })
      .catch(console.error)
      .finally(() => setLoading(false));

  //   setItems([
  //   {
  //     id: 1,
  //     title: "Your Success Starts Here",
  //     subtitle: "Discover tenders that match your business",
  //     button_text: "Get Started",
  //     imagePath: "hero1.jpg",
  //   },
  //   {
  //     id: 2,
  //     title: "Grow with BandiHub",
  //     subtitle: "The easiest way to stay updated on new opportunities",
  //     button_text: "Explore Now",
  //     imagePath: "hero2.png",
  //   },
  // ]);

  };

  const handleSave = () => {
    // setFormLoading(true);
    const method = editItemId ? "POST" : "PUT"; // or POST for both depending on backend
    const endpoint = editItemId ? `${url}auth/update-hero-section/${editItemId}` : `${url}auth/hero-sections`;
    const formData = new FormData();

    Object.entries(formState).forEach(([key, value]) => {
      formData.append(key, value);
    });

    console.log("formdata",formState);

    fetch(endpoint, { method, body: formData })
      .then((res) => res.json())
      .then(() => {
        fetchItems();
        setFormState({ title: "", subtitle: "", button_text: "", image_path: "" , previewImage: ""});
        setEditItemId(null);
        setTab(0);
      })
      .finally(() => setFormLoading(false));

  };

  const openEdit = (item) => {
    setFormState({
      title: item.title,
      subtitle: item.subtitle,
      button_text: item.button_text,
      button_link: item.button_link || "", // <-- new field
      image_path: "", // we'll update this on file selection
      previewImage: item.image_path ? `${rootUrl}/HomePageuploads/${item.image_path}` : "", // adjust path if needed
    });
     console.log("update data",formState);
    setEditItemId(item.id);
    setTab(1);
   

  };

  const columns = [
    { Header: "ID", accessor: "id" },
    { Header: "Title", accessor: "title" },
    // { Header: "Subtitle", accessor: "subtitle" },
    {
      Header: "Subtitle",
      accessor: "subtitle",
      Cell: ({ value }) => (
        <Tooltip title={value}>
          <div
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: 350,
            }}
          >
            {value}
          </div>
        </Tooltip>
      )
    },
    { Header: "Button Text", accessor: "button_text" },
    { Header: "Button Link", accessor: "button_link" },
    {
      Header: "Actions",
      accessor: "actions",
      Cell: ({ row }) => (
        <Button variant="contained" sx={{ backgroundColor: "#183759",color:"#fff", "&:hover": { backgroundColor: "#204b80" } }} size="small" onClick={() => openEdit(row.original)}>
          Edit
        </Button>
      ),
    },
  ];

  const rows = items.map((i) => ({
    id: i.id,
    title: i.title,
    subtitle: i.subtitle,
    button_text: i.button_text,
    button_link: i.button_link,
    image_path: i.image_path,
    actions: "",
  }));

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop open={loading || formLoading} sx={{ zIndex: 1000, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox mx={2} mt={-3} py={3} px={2} variant="gradient" bgColor="#183759" borderRadius="lg" coloredShadow="info">
                <MDTypography variant="h6" color="white">
                  Hero Section Manager
                </MDTypography>
              </MDBox>
              <Box sx={{ width: "100%" }}>
                <Tabs value={tab} onChange={(e, v) => setTab(v)} variant="fullWidth">
                  <Tab label="List" />
                  {/* <Tab label={editItemId ? "Edit Hero" : "Add Hero"} /> */}
                  {editItemId && <Tab label="Edit Hero" />}
                </Tabs>

                {tab === 0 && (
                  <MDBox pt={3}>
                    <DataTable
                      table={{ columns, rows }}
                      isSorted={false}
                      entriesPerPage={{ defaultValue: 10 }}
                      showTotalEntries={false}
                      noEndBorder
                      currentPageIndex={currentPageIndex}
                      setCurrentPageIndex={setCurrentPageIndex}
                    />
                  </MDBox>
                )}

                {tab === 1 && (
                  <MDBox pt={3} px={2}>
                    <Grid container spacing={2} justifyContent="center">
                      <Grid item xs={12} sm={8} md={6}>
                        <TextField
                          label="Title"
                          fullWidth
                          value={formState.title}
                          onChange={(e) => setFormState({ ...formState, title: e.target.value })}
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          label="Subtitle"
                          fullWidth
                          multiline
                          value={formState.subtitle}
                          onChange={(e) => setFormState({ ...formState, subtitle: e.target.value })}
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          label="Button Text"
                          fullWidth
                          value={formState.button_text}
                          onChange={(e) => setFormState({ ...formState, button_text: e.target.value })}
                          sx={{ mb: 2 }}
                        />
                        <TextField
                          label="Button Link"
                          fullWidth
                          value={formState.button_link}
                          onChange={(e) => setFormState({ ...formState, button_link: e.target.value })}
                          sx={{ mb: 2 }}
                        />

                        {formState.previewImage && !formState.image_path && (
                          <Box sx={{ mb: 2 }}>
                            <img
                              src={formState.previewImage}
                              alt="Preview"
                              style={{ width: "100%", maxHeight: "200px", objectFit: "contain", border: "1px solid #ccc", borderRadius: 4 }}
                            />
                          </Box>
                        )}
                        <TextField
                          label="Image Upload"
                          type="file"
                          fullWidth
                          onChange={(e) =>
                            setFormState({
                              ...formState,
                              image_path: e.target.files[0],
                              previewImage: "", // remove preview to show the newly selected file
                            })
                          }
                          sx={{ mb: 2 }}
                          InputLabelProps={{ shrink: true }}
                        />
                        <Button onClick={handleSave} variant="contained" fullWidth sx={{ mb:5, backgroundColor: "#183759", color:"#fff", "&:hover": { backgroundColor: "#204b80" } }}>
                          {editItemId ? "Update Hero" : "Add Hero"}
                        </Button>
                      </Grid>
                    </Grid>
                  </MDBox>
                )}
              </Box>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default HeroSectionDashboard;
